(function($) {
$(document).ready(function() {
	var $win = $(window),
		$body = $('body');

	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
		  $(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  $(this).wrap("<div class='responsive-embed'/>");
		}
	});

	var interval = setInterval(function() {
		clearInterval(interval);

		// $('.ae-cform-item-submit-button').wrapInner('<div class="button arrow"></div>');
		$('#ae-cform-reg-item-email-1 input').attr('placeholder', 'Email Address');
		$('#ae-cform-reg-item-postcode-1 input').attr('placeholder', 'Zip Code');

		$('.js-tubepress-gallery .tubepress-cursor-pointer').fancybox();
	}, 100);


    initToggleMode()

    function initToggleMode() {
        const UMGGR_STORE_MODE_OPTION = true
        const skinModeKey = 'umggr-skin-mode'
        let currentMode = 'dark'

        $('.toggl-mode').append('<div class="toggle-container dark-mode"><p>Dark Mode</p><div class="toggle-switch"></div></div>');

        if (UMGGR_STORE_MODE_OPTION && typeof localStorage !== 'undefined') {
            let storedMode = localStorage.getItem(skinModeKey)
            if (storedMode) {
                currentMode = storedMode
                setSkinMode(currentMode)
            }
        }

        $('.toggle-container .toggle-switch').on('click', function () {
            if ($('.toggle-container').hasClass('dark-mode')) {
                setSkinMode('light')
                currentMode = 'light'
            } else {
                setSkinMode('dark')
                currentMode = 'dark'
            }

            if (UMGGR_STORE_MODE_OPTION && typeof localStorage !== 'undefined') {
                localStorage.setItem(skinModeKey, currentMode)
            }
        })
    }

    function setSkinMode(mode) {
        switch (mode) {
            case "dark":
                $('.toggle-container').removeClass('light-mode')
                $('.toggle-container').addClass('dark-mode')
                $('.toggle-container p').html('Dark Mode')
                $('body').removeClass('light-mode')
                break;
            case "light":
                $('.toggle-container').removeClass('dark-mode')
                $('.toggle-container').addClass('light-mode')
                $('.toggle-container p').html('Light Mode')
                $('body').addClass('light-mode')
                break;
        }
    }


	$(window).on('load', function() {

		$('.js-subscribe a').on('click', function(e) {
			e.preventDefault();

			var name = $(this).attr('href'),
			section = $(name);

			$('html, body').animate({
				scrollTop: section.offset().top
			}, 'normal');
			// if( $body.hasClass('home') ) {
			// } else {
			// 	$('.ae-cform-modal-display-cta').trigger('click');
			// }
			$('.js-off-canvas-overlay').trigger('click');
		});

		$('.off-canvas .ae-cform-modal-display-cta').on('click', function() {
			$('.js-off-canvas-overlay').trigger('click');
		});

		if( $body.hasClass('home') || $body.hasClass('single-artist') ) {
		}
		if( $body.hasClass('single-artist') ) {
			$('.js-release-list').slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				dots: false,
				responsive: [
					{
						breakpoint: 815,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			});
			$('.js-video-list').slick({
				slidesToShow: 2,
				slidesToScroll: 2,
				dots: false,
				responsive: [
					{
						breakpoint: 815,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			});
		}
		if( $body.hasClass('home') ) {
			var $banner = $('.js-banner');

			$banner.slick({
				slidesToShow: 1, 
				slidesToScroll: 1,
				dots: false,
				appendArrows: $('.section-banner .arrows')
			});

			$('.mouse').on('click', function(e) {
				e.preventDefault();
	
				$('html, body').animate({
					scrollTop: $('.section-artists').offset().top
				}, 'normal');
			});

			// $('.main-home .section').each(function(){
			// 	var self = $(this);
			
			// 	$(this).waypoint({
			// 		handler: function(direction) {
			// 			// if(direction == 'down') {
			// 			// }

			// 			// $('.main-home .section').removeClass('show');
			// 			self.addClass('show');
			// 			self.find('.js-release-list').addClass('appear');
						
			// 			setTimeout(function(){ 
			// 				self.find('.js-release-list').addClass('stop'); 
			// 			}, 5000);

			// 			// self.find('.sphere').css
			// 		}, offset: '50%'
			// 	});
			// });

			if($win.width() >= 420) {
				var interval = setInterval(function() {
					clearInterval(interval);
				}, 100);
			}
		} // home

		if( $('.main').hasClass('main-default') ) {
			var $headerHt = $('.page-header').height() + 47;

			$('.page-content').css('padding-top', $headerHt);

			$win.resize(function() {
				var $headerHt = $('.page-header').height() + 47;

				$('.page-content').css('padding-top', $headerHt);
			});

			// var controller = new ScrollMagic.Controller();
			// var tween = new TimelineMax()
			// 	.to('.sphere', 1, {
			// 		top: '10%',
			// 	})
			// 	.to('.sphere', 1, {
			// 		top: '50%',
			// 		width: 550,
			// 		height: 550,
			// 	});
			// var scene = new ScrollMagic.Scene({triggerElement: '.type-page', duration: 1100, offset: -15})
			// .setTween(tween)
			// .addTo(controller);
		}

		if($win.width() >= 420) {

		}

		// if( $('.main').hasClass('main-releases') ) {
		// 	var ppp = 12; // Post per page
		// 	var pageNumber = 1;
	
		// 	function load_posts(){
		// 		pageNumber++;
		// 		var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_release_ajax';
		// 		jQuery.ajax({
		// 			type: "POST",
		// 			dataType: "html",
		// 			url: ajax_posts.ajaxurl,
		// 			data: str,
		// 			success: function(data){
		// 				var $data = $(data);
		// 				if($data.length){
		// 					$("#ajax-music").append($data);

		// 					$("#more_releases").attr("disabled",false).removeClass('loading');
		// 				} else{
		// 					$("#more_releases").attr("disabled",true).addClass('done');
		// 				}
		// 			},
		// 			error : function(jqXHR, textStatus, errorThrown) {
		// 				$('#ajax-music .page-footer').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
		// 			}
	
		// 		});
		// 		return false;
		// 	}
	
		// 	$("#more_releases").on("click",function(e){ // When btn is pressed.
		// 		e.preventDefault();
		// 		$(this).addClass('loading');
		// 		$("#more_releases").attr("disabled",true); // Disable the button, temp.
		// 		load_posts();
		// 		// $(this).insertAfter('#ajax-music'); // Move the 'Load More' button to the end of the the newly added posts.
		// 	});

		// 	$win.on("scroll", function() {
		// 		var scrollHeight = $(document).height();
		// 		var scrollPosition = $win.height() + $win.scrollTop();
		// 		if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
		// 			// when scroll to bottom of the page
		// 			$("#more_releases").trigger('click');
		// 		}
		// 	});
		// }

		// if( $('.main').hasClass('main-videos') ) {
		// 	var ppp = 6; // Post per page
		// 	var pageNumber = 1;
	
		// 	function load_posts(){
		// 		pageNumber++;
		// 		var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_video_ajax';
		// 		jQuery.ajax({
		// 			type: "POST",
		// 			dataType: "html",
		// 			url: ajax_posts.ajaxurl,
		// 			data: str,
		// 			success: function(data){
		// 				var $data = $(data);
		// 				if($data.length){
		// 					$("#ajax-videos").append($data);

		// 					$("#more_videos").attr("disabled",false).removeClass('loading');
		// 				} else{
		// 					$("#more_videos").attr("disabled",true).addClass('done');
		// 				}
		// 			},
		// 			error : function(jqXHR, textStatus, errorThrown) {
		// 				$('#ajax-videos .page-footer').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
		// 			}
	
		// 		});
		// 		return false;
		// 	}
	
		// 	$("#more_videos").on("click",function(e){ // When btn is pressed.
		// 		e.preventDefault();
		// 		$(this).addClass('loading');
		// 		$("#more_videos").attr("disabled",true); // Disable the button, temp.
		// 		load_posts();
		// 		// $(this).insertAfter('#ajax-music'); // Move the 'Load More' button to the end of the the newly added posts.
		// 	});

		// 	$win.on("scroll", function() {
		// 		var scrollHeight = $(document).height();
		// 		var scrollPosition = $win.height() + $win.scrollTop();
		// 		if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
		// 			// when scroll to bottom of the page
		// 			$("#more_videos").trigger('click');
		// 		}
		// 	});
		// }
	});
}); 
})(jQuery);